module.exports = __webpack_public_path__ + "media/images/psp/star-alliance-4d48279b06993fae98b66d34a8d4c552.png";